"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOnboardingSignedUrlBodyToJSON = exports.CreateOnboardingSignedUrlBodyFromJSONTyped = exports.CreateOnboardingSignedUrlBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CreateOnboardingSignedUrlBodyFromJSON(json) {
    return CreateOnboardingSignedUrlBodyFromJSONTyped(json, false);
}
exports.CreateOnboardingSignedUrlBodyFromJSON = CreateOnboardingSignedUrlBodyFromJSON;
function CreateOnboardingSignedUrlBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'phoneNumber': !(0, runtime_1.exists)(json, 'phoneNumber') ? undefined : (0, _1.PhoneNumberBodyFromJSON)(json['phoneNumber']),
        'firstName': !(0, runtime_1.exists)(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !(0, runtime_1.exists)(json, 'lastName') ? undefined : json['lastName'],
        'wallets': !(0, runtime_1.exists)(json, 'wallets') ? undefined : json['wallets'],
        'redirectUrl': !(0, runtime_1.exists)(json, 'redirectUrl') ? undefined : json['redirectUrl'],
    };
}
exports.CreateOnboardingSignedUrlBodyFromJSONTyped = CreateOnboardingSignedUrlBodyFromJSONTyped;
function CreateOnboardingSignedUrlBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'phoneNumber': (0, _1.PhoneNumberBodyToJSON)(value.phoneNumber),
        'firstName': value.firstName,
        'lastName': value.lastName,
        'wallets': value.wallets,
        'redirectUrl': value.redirectUrl,
    };
}
exports.CreateOnboardingSignedUrlBodyToJSON = CreateOnboardingSignedUrlBodyToJSON;
